import { Pipe, PipeTransform } from '@angular/core';
import { GuestService } from '../services/guest.service';

@Pipe({
    name: 'currencyDecimalFormatter',
    standalone: false
})
export class CurrencyDecimalFormatter implements PipeTransform {

  constructor(public guestService: GuestService) {}
  
  transform(value: number | string | Number): any {
    // Convert value to a number if it's a string or a Number object
    let num: number;
    if (typeof value === 'string' || value instanceof String) {
      num = Number(value);
    } else if (value instanceof Number) {
      num = value.valueOf();
    } else {
      num = value;
    }
    
    // Handle invalid number conversion
    if (isNaN(num)) {
      return value;
    }

    return num.toFixed(this.guestService.widgetSettings.NumberOfFractionalDigits || 2);
  }
}


